import React from "react";
import "./style.css";

const Schedule = () => {
  const row1 = [
    {
      time: "",
      group: "",
    },
    {
      time: "17:30-19:00",
      group: "10-14 y.o.",
    },
    {
      time: "17:30-19:00",
      group: "10-14 y.o./7-9 y.o.",
    },
    {
      time: "16:30-17:30",
      group: "4-6 y.o.",
    },
    {
      time: "17:30-19:00",
      group: "10-14 y.o.",
    },
    {
      time: "9:00-10:00",
      group: "4-6 y.o.",
    },
    {
      time: "",
      group: "",
      classStyle: "sunday",
    },
  ];

  const row2 = [
    {
      time: "",
      group: "",
    },
    {
      time: "",
      group: "",
    },
    {
      time: "",
      group: "",
    },
    {
      time: "17:40-18:40",
      group: "7-9 y.o.",
    },
    {
      time: "",
      group: "",
    },
    {
      time: "10:10-11:10",
      group: "7-9 y.o.",
    },
    {
      time: "",
      group: "",
      classStyle: "sunday",
    },
  ];

  const row3 = [
    {
      time: "",
      group: "",
      classStyle: "last_row",
    },
    {
      time: "",
      group: "",
      classStyle: "last_row",
    },
    {
      time: "",
      group: "",
      classStyle: "last_row",
    },
    {
      time: "",
      group: "",
      classStyle: "last_row",
    },
    {
      time: "",
      group: "",
      classStyle: "last_row",
    },
    {
      time: "",
      group: "",
      classStyle: "last_row",
    },
    {
      time: "",
      group: "",
      classStyle: "last_row sunday",
    },
  ];

  return (
    <div className="scheduleContainer" id="schedule">
      <h2>SCHEDULE</h2>
      <p>*valid after the groups are formed</p>
      {window.innerWidth > 600 ? (
        <table>
          <tr>
            <th>
              <p className="p-table">monday</p>
            </th>
            <th>
              <p className="p-table">tuesday</p>
            </th>
            <th>
              <p className="p-table">wednesday</p>
            </th>
            <th>
              <p className="p-table">thursday</p>
            </th>
            <th>
              <p className="p-table">friday</p>
            </th>
            <th>
              <p className="p-table">saturday</p>
            </th>
            <th className="sunday">
              <p className="p-table">sunday</p>
            </th>
          </tr>
          <tr>
            {row1.map(({ time, group, classStyle }, index) => (
              <td key={`${index}`} className={classStyle}>
                <h6>{time}</h6>
                <p>{group}</p>
              </td>
            ))}
          </tr>
          <tr>
            {row2.map(({ time, group, classStyle }, index) => (
              <td key={`${index}`} className={classStyle}>
                <h6>{time}</h6>
                <p>{group}</p>
              </td>
            ))}
          </tr>
          <tr>
            {row3.map(({ time, group, classStyle }, index) => (
              <td key={`${index}`} className={classStyle}>
                <h6>{time}</h6>
                <p>{group}</p>
              </td>
            ))}
          </tr>
        </table>
      ) : (
        <div
          id="carouselExampleControlsNoTouching"
          class="carousel slide"
          data-bs-touch="false"
        >
          <div class="carousel-inner">
            <div class="carousel-item active">
              <h3>tuesday</h3>
              <div className="time">
                <h6>17:30-19:00</h6>
                <p>10-14 y.o.</p>
              </div>
              <h3 className="h3_mob_schedule">wednesday</h3>
              <div className="time">
                <h6>17:30-19:00</h6>
                <p>10-14 y.o.</p>
                <p>7-9 y.o.</p>
              </div>
              <h3 className="h3_mob_schedule">thursday</h3>
              <div className="time">
                <h6>16:30-17:30</h6>
                <p>4-6 y.o.</p>
              </div>
              <div className="time">
                <h6>17:40-18:40</h6>
                <p>7-9 y.o.</p>
              </div>
              <h3 className="h3_mob_schedule">friday</h3>
              <div className="time">
                <h6>17:30-19:00</h6>
                <p>10-14 y.o.</p>
              </div>
              <h3 className="h3_mob_schedule">saturday</h3>
              <div className="time">
                <h6>9:00-10:00</h6>
                <p>4-6 y.o.</p>
              </div>
              <div className="time">
                <h6>10:10-11:10</h6>
                <p>7-9 y.o.</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Schedule;
